import { InjectionToken } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';

export interface BdMoveRequest {
  shareableType: ShareableType;
  shareableId: string;
  shareableName: string;
  shareableTypeLabel?: string;
  modifiedDate?: string;
}

export interface BdMoveResult {
  targetFolderId: string;
}

/**
 * Opens the "Verschieben" dialog for a single shareable and emits exactly once:
 *  - a `{ targetFolderId }` result when the move ran,
 *  - `null` when the dialog was cancelled or closed without moving.
 *
 * The implementation lives in `@bindoc-projects/resource-lib/registration` (the same dialog the
 * workspace's row menus open), so apps that don't need it don't pull the
 * folder tree/stepper machinery into their eager bundle. Apps that need it
 * should provide the token via `provideMoveDialog()` (exported from
 * `@bindoc-projects/resource-lib/registration`).
 */
export type BdMoveOpener = (
  request: BdMoveRequest,
) => Observable<BdMoveResult | null>;

export const BD_MOVE_OPENER = new InjectionToken<BdMoveOpener>(
  'BD_MOVE_OPENER',
);
